
import * as React from 'react'
import Slider from 'react-slick'
import styled from 'styled-components'

// eslint-disable-next-line react/display-name
const EmbeddedSlickComponent: typeof Slider = React.forwardRef((props: any, ref) =>
  <div className={ props.className }><Slider { ...props } className={ undefined } ref={ ref }/></div>
) as any

export const StyledSlickComponent = styled(EmbeddedSlickComponent)`
  .slick-slider {
    display: block;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    -ms-user-select: none;
    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
  }

  .slick-list {
    width: 100%;
    position: relative;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  .slick-list:focus {
    outline: none;
  }
  
  .slick-list.dragging {
    cursor: pointer;
    cursor: hand;
  }
  
  .slick-slider .slick-track,
  .slick-slider .slick-list {
    transform: translate3d(0,0,0);
  }

  .slick-track {
    display: table;
    position: relative;
    top: 0;
    left: 0;
  }
  
  .slick-loading .slick-track {
    visibility: hidden;
  }
  
  .slick-slide {
    display: none;
    min-height: 1px;
  }
  
  .slick-initialized .slick-slide {
    display: table-cell;
  }
  
  [dir='rtl'] .slick-slide {
    float: right;
  }
  
  .slick-slide img {
    display: block;
  }
  
  .slick-slide.slick-loading img {
    display: none;
  }
  
  .slick-slide.dragging img {
    pointer-events: none;
  }
  
  .slick-loading .slick-slide {
    visibility: hidden;
  }
  
  .slick-vertical .slick-slide {
    display: block;
    height: auto;
    border: 1px solid transparent;
  }
  
  .slick-arrow.slick-hidden {
    display: none;
  }
  
  .slick-prev {
    left: -14px !important;
    margin-left: 0.3rem;
  }
  
  .slick-next {
    right: -14px !important;
    margin-right: 0.3rem;
  }
  .slick-prev, .slick-next{
    height:14px !important;
    width:14px !important;
  }
  
  .menuAside-nav {
   margin: 0 16px;
  }

  .slick-col {
    padding-right: 1.25rem;
    padding-left: 1.25rem;
    @media (min-width: 60em) {
      padding-right: 0.625rem;
      padding-left: 0.625rem;
    }
  }

  .slick-prev,
  .slick-next {
    display: block;
    position: absolute;
    top: 50%;
    width: 15px;
    height: 30px;
    padding: 0;
    border: none;
    font-size: 0;
    line-height: 0;
    outline: none;
    color: transparent;
    transform: translate(0,-50%);
    cursor: pointer;
    background: transparent url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjE1cHgiIGhlaWdodD0iMzBweCIgdmlld0JveD0iMCAwIDE1IDMwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbG5zOnNrZXRjaD0iaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoL25zIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy40LjMgKDE2NjE4KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5wcmV2PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9Ikljw7RuZXMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHNrZXRjaDp0eXBlPSJNU1BhZ2UiPgogICAgICAgIDxnIGlkPSJwcmV2IiBza2V0Y2g6dHlwZT0iTVNBcnRib2FyZEdyb3VwIiBmaWxsPSIjNzE4NDkxIj4KICAgICAgICAgICAgPHBhdGggZD0iTTEzLjU4NTMyNzIsMCBMMCwxNC45OTg5MTkyIEwxMy41ODUzMjcyLDI5Ljk5OTgwMzUgTDE0Ljk5OTkwMzcsMjguNjY2NTQ0NCBMMi42MjIxMTgzNywxNC45OTg5MTkyIEwxNC45OTk5MDM3LDEuMzMzMjU5MSBMMTMuNTg1MzI3MiwwIFoiIGlkPSJQYWdlLTEiIHNrZXRjaDp0eXBlPSJNU1NoYXBlR3JvdXAiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==) center no-repeat;
  }

  .slick-prev:hover,
  .slick-prev:focus,
  .slick-next:hover,
  .slick-next:focus {
    outline: none;
  }

  .slick-prev {
    left: -20px;
  }

  .slick-next {
    right: -25px;
    transform: rotate(180deg) translate(0,50%);
  }

  .slick-dots {
    display: block;
    position: absolute;
    bottom: -45px;
    width: 100%;
    padding: 0;
    text-align: center;
    list-style: none;
  }
  
  .slick-dots li {
    display: inline-block;
    position: relative;
    width: 20px;
    height: 20px;
    margin: 0 5px;
    padding: 0;
    cursor: pointer;
  }
  
  .slick-dots li button {
    display: block;
    width: 20px;
    height: 20px;
    padding: 5px;
    border: 0;
    font-size: 0;
    line-height: 0;
    outline: none;
    color: transparent;
    background: transparent;
    cursor: pointer;
  }
  
  .slick-dots li button:hover,
  .slick-dots li button:focus {
    outline: none;
  }
  
  .slick-dots li button:hover:before,
  .slick-dots li button:focus:before {
    opacity: 1;
  }
  
  .slick-dots li button:before {
    content: '•';
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    text-align: center;
    font-size: 20px;
    line-height: 20px;
    color: ${ props => props.theme.colors.clr_0 };
    opacity: .25;
  }

  .slick-dots li.slick-active button:before {
    color: ${ props => props.theme.colors.clr_0_dark };
    opacity: .75;
  }
`
